import { render, staticRenderFns } from "./SliderEncuesta.vue?vue&type=template&id=7c81971b&"
import script from "./SliderEncuesta.vue?vue&type=script&lang=js&"
export * from "./SliderEncuesta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QSlider} from 'quasar'
component.options.components = Object.assign({QSlider}, component.options.components || {})
